module.exports = __webpack_public_path__ + "mobile_text.6ff77470d25e168d8e77f0138e908aca.svg";